// redux/actionDispatcher/categoryModalDispatcher.js
export const showAddCategoryModal = () => {
    return {
      type: "SHOW_ADD_CATEGORY_MODAL",
    };
  };
  
  export const hideAddCategoryModal = () => {
    return {
      type: "HIDE_ADD_CATEGORY_MODAL",
    };
  };
  


  // redux/actionDispatcher/categoryModalDispatcher.js
export const showAddKeywordModal = () => {
    return {
      type: "SHOW_ADD_KEYWORD_MODAL",
    };
  };
  
  export const hideAddKeywordModal = () => {
    return {
      type: "HIDE_ADD_KEYWORD_MODAL",
    };
  };
  